module.exports = __webpack_public_path__ + "img/answer-c2-1.f15a3b5a.png";